import styled, { css } from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { media } from 'ui/rwd'
import { Row, Col, Container } from 'reactstrap'
import HLogotypeSvg from '../../../components/shared/Store/HLogotypeSvg'
import ZTLogotypeSvg from '../../../components/shared/Store/ZTLogotypeSvg'

const Blur = css`
  filter: blur(5px);
  -webkit-filter: blur(5px);
  z-index: 2;
  top: 33px;
  transform: translate(0, 5px);

  &::before {
    content: ' ';
    z-index: 110;
    position: fixed;
    background-color: #00000059;
    top: -10px;
    left: 0;
    right: 0;
    width: auto;
    height: 100%;
    display: block;
    margin-left: -15px;
    margin-right: -15px;
  }
`

const BlurredWrapper = styled.div`
  ${ifProp('blurred', Blur, '')}
`

const StoreTopBar = styled.div`
  background-color: ${theme('headerBackgroundColor', 'white')};
  color: ${theme('storeName', 'black')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: -15px;
  margin-right: -15px;
  padding: 0.7rem 0;
  transform: none;
  position: sticky;
  top: 0;
  z-index: 100;
`

const StoreTopBarContent = styled(Col)`
  display: flex;
  justify-content: space-between;
`

const StoreHeader = styled.div`
  background-color: ${theme('storeBackgroundColor', 'white')};
  color: ${theme('storeMessageText', 'black')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -15px;
  margin-right: -15px;
  position: sticky;
  top: 4rem;
  ${ifProp('modalopen', 'z-index: 10;', '')}
`
const StoreIdBox = styled.div`
  display: inline-block;
  border-radius: 12px;
  color: ${theme('storeName', 'black')};
  padding: 0.6rem 1rem;
  z-index: 2;
  ${media.sm.down`
    font-size: 1rem;
  `}
`

const StoreButtons = styled.div`
  grid-area: buttons;
  display: inline-block;
  position: relative;
`

const StoreInfoClaim = styled.div`
  grid-area: description;
  display: flex;
  align-items: center;
  color: ${theme('storeMessageText')};
`
const StoreDetailsGrid = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-gap: 1rem 2rem;
  grid-template-areas:
    'name name'
    'description buttons';
  grid-template-rows: auto;
  grid-template-columns: minmax(0, 8fr) minmax(min-content, max-content);
  ${media.sm`
   margin-top:0;
    grid-template-areas:
      "name"
      "description"
      "buttons";
    grid-template-columns: 1fr;
  `}
`

const StoreName = styled.h2`
  grid-area: name;
  border-radius: 6px;
  margin: 0;
  text-align: left;
  color: ${theme('storeMessageText', 'black')};

  ${media.lg`
  `}
`

const StoreHeaderRow = styled(Row)`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`

const HLogo = styled(HLogotypeSvg).attrs(props => ({
  color: theme('burger', 'black')(props)
}))`
  cursor: pointer;
  width: 1.8rem;
  height: 1.8rem;
`

const ZTLogo = styled(ZTLogotypeSvg).attrs(props => ({
  color: theme('burger', 'black')(props)
}))`
  cursor: pointer;
  width: 1.8rem;
  height: 1.8rem;
  margin: 2px;
  padding: 2px;
`

const Content = styled(Container)`
  background: ${theme('storeBackgroundColor', 'white')};
  position: relative;
  padding: 1rem 0;
  padding-bottom: 3rem;
  z-index: 5;
  transform: none;
`

export {
  BlurredWrapper,
  Content,
  StoreTopBar,
  StoreTopBarContent,
  StoreIdBox,
  StoreButtons,
  StoreInfoClaim,
  StoreName,
  StoreHeaderRow,
  StoreHeader,
  HLogo,
  StoreDetailsGrid,
  ZTLogo
}
